export default __webpack_public_path__ + "static/char-s-35-en-9471cf4d758565cb98929e481171935d.png";